/**
 * A custom directive to handle cell country code changes.
 *
 * TODO: read http://stackoverflow.com/questions/14049480/what-are-the-nuances-of-scope-prototypal-prototypical-inheritance-in-angularjs
 */
App.directive('ngCellFilter', ['cellHelper', 'formHelper', '$rootScope', function(cellHelper, formHelper, $rootScope) {
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            void 0;
            void 0;
            void 0;

            /**
             * Watch out for keypress.
             */
            elem.on('keypress', function(evt) {
                void 0;

                scope.$apply(function() {
                    // enforce country code
                    cellHelper.enforceCountryCode($rootScope, ngModel, elem, evt);
                });
            });

            elem.on('keyup', function(evt) {
                void 0;

                scope.$apply(function() {
                    // enforce country code
                    cellHelper.enforceCountryCode($rootScope, ngModel, elem, evt);

                    //enforce numbers only
                    if($rootScope.formData.cell.match(/[^\d\+\s\-]/g) != null)
                    {
                    	$rootScope.formData.cell = $rootScope.formData.cell.substr(0,$rootScope.formData.cell.length-2);
                    }

                    // validate overall text
                    cellHelper.validateText($rootScope, ngModel, elem, evt)
                });
            });

            // initialize placeholder
            cellHelper.setCellCountryCode($rootScope, ngModel);
        }
    }
}]);
